/* The code is defining a regular expression pattern called `RESET_PASSWORD_REGEX`. This pattern is
used to validate a password reset input. */
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"§$%&/()=?´°^²³{[\]}\*+~#',;.:\-_@])(?=.{8,})/;

export const REMOVE_WHITESPACE = /\s/g;
export const URL = /^(http|https):\/\/[^ "]+$/;

export const ALPHA_NUMERIC = /[a-zA-Z0-9]/;
